import Parse from "html-react-parser";

export const ParseHtml = (value) => {
  return value ? Parse(value) : "";
};
